module.exports = __webpack_public_path__ + "static/img/img1.e0d8663a.png";